import React from 'react';

const IconArrowRight = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="26px" height="13px" viewBox="0 0 26 13">
        <path fill="currentColor" clipRule="evenodd" fillRule="evenodd" d="M25.68 5.92l-3.86-3.83c-.65-.64-1.29-1.28-1.95-1.91a.553.553 0 0 0-.81-.01c-.23.22-.23.59-.01.82.05.06.1.11.16.16l4.54 4.51c.06.06.12.12.21.23H.87c-.14 0-.27.01-.4.03-.27.06-.47.29-.47.56 0 .27.19.5.45.55.13.03.27.04.41.03h23.09c-.1.11-.16.18-.22.24-1.5 1.49-2.99 2.98-4.49 4.46-.09.09-.18.18-.25.28-.18.24-.13.58.1.77.26.22.58.18.88-.11 1.91-1.89 3.81-3.78 5.71-5.67.42-.41.42-.7 0-1.11z" />
    </svg>
);

export default IconArrowRight;